// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__N1aNh","modal":"style_modal__+qobU","closeModalContainer":"style_closeModalContainer__dDoFf","error":"style_error__2T8X+","text":"style_text__nsxWA"};